import cn from "classnames";
import type { Sorting, TableEntry } from "@wptb/utils/react";

interface TableListProps {
  onSelect: (table: TableEntry) => void;
  sorting: [Sorting, (by: any) => void];
  isLoading?: boolean;
  items: TableEntry[];
  columns?: string[];
  checkbox?: boolean;
  checked?: boolean;
  onAllCheck?: (checked: boolean) => void;
  noItemsMessage?: string;
  htmlColumns?: Record<string, boolean>;
}

const columnConfig = {
  id: { label: "ID", width: "80px" },
  title: { label: "Title" },
  date: { label: "Created" },
  modified: { label: "Last Modified" },
} as const;

const TableList = ({
  onSelect,
  sorting: [sort, sortBy],
  isLoading,
  items,
  columns = Object.keys(columnConfig),
  checkbox,
  checked,
  onAllCheck,
  noItemsMessage = "No tables found",
  htmlColumns,
}: TableListProps) => {
  return (
    <table
      className={cn("wptb-v2-table-list", {
        "wptb-table-loading": isLoading,
      })}
    >
      <colgroup>
        {checkbox && (
          <col
            style={{
              width: "40px",
            }}
          />
        )}
        {columns.map((column) => (
          <col
            key={column}
            style={{
              width: columnConfig[column].width,
            }}
          />
        ))}
      </colgroup>
      <thead>
        <tr>
          {checkbox && (
            <th>
              <input
                type="checkbox"
                checked={!!checked}
                onChange={(e) => onAllCheck?.(e.currentTarget.checked)}
              />
            </th>
          )}
          {columns.map((column) => (
            <th key={column} onClick={() => sortBy(column)}>
              {columnConfig[column].label}
              <button
                type="button"
                className={cn("wptb-table-sort-btn", {
                  "wptb-sort-btn-asc":
                    sort.by === column && sort.order === "asc",
                  "wptb-sort-btn-desc":
                    sort.by === column && sort.order !== "asc",
                })}
              />
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {isLoading ? (
          Array(5)
            .fill(0)
            .map((_, i) => (
              <tr key={i}>
                {checkbox && <td />}
                {columns.map((column) => (
                  <td key={column}>
                    <div data-column={column} />
                  </td>
                ))}
              </tr>
            ))
        ) : !items.length ? (
          <tr>
            <td colSpan={columns.length + (checkbox ? 1 : 0)}>
              <p>{noItemsMessage}</p>
            </td>
          </tr>
        ) : (
          items.map((post) => (
            <tr onClick={() => onSelect(post)} key={post.id}>
              {checkbox && (
                <td>
                  <input type="checkbox" defaultChecked={checked} />
                </td>
              )}
              {columns.map((column) => (
                <td key={column}>
                  {htmlColumns?.[column] ? (
                    <div dangerouslySetInnerHTML={{ __html: post[column] }} />
                  ) : (
                    post[column] || "-"
                  )}
                </td>
              ))}
            </tr>
          ))
        )}
      </tbody>
    </table>
  );
};
export default TableList;
